import React from 'react';
import styled from '@emotion/styled';
import withTranslation from '../../../../hoc/withTranslation';
import { calculateMaxDistance } from '../../../../utils/evProfiles';
import { fontSize, colors } from '../../../../global/variables';
import { BatteryIcon } from '../../../../icons/EVIcons';

const StyledMaxDistanceInfo = styled.div`
  background: rgba(34, 205, 200, 0.1);
  border: 1px solid rgba(34, 205, 200, 0.4);
  border-radius: 0.12rem;
  padding: 0.75rem;
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 0.25rem 0.75rem;
  align-items: center;
`;

const StyledIconWrapper = styled.div`
  grid-row: 1 / 3;
  display: flex;
  align-items: center;
`;

const StyledMaxDistanceLabel = styled.span`
  font-size: ${fontSize.small};
  color: rgba(15, 22, 33, 0.7);
  font-weight: 500;
`;

const StyledMaxDistanceValue = styled.span`
  font-size: ${fontSize.medium};
  color: ${colors.primaryColor};
  font-weight: 700;
`;

const EVMaxDistanceDisplay = ({
  range,
  translations: {
    wizard: {
      fleet: { evMaxDistanceLabel },
    },
  },
}) => {
  if (!range) return null;

  const maxDistance = calculateMaxDistance(range);

  return (
    <StyledMaxDistanceInfo data-test-id="ev-max-distance">
      <StyledIconWrapper>
        <BatteryIcon size={24} />
      </StyledIconWrapper>
      <StyledMaxDistanceLabel>{evMaxDistanceLabel}</StyledMaxDistanceLabel>
      <StyledMaxDistanceValue>{(maxDistance / 1000).toFixed(1)} km</StyledMaxDistanceValue>
    </StyledMaxDistanceInfo>
  );
};

export default withTranslation(EVMaxDistanceDisplay);
